import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { createReportVersionVulnerabilityRoute, editReportVersionVulnerabilitiesRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { CreateReportVulnerabilityForm } from "app/component/report-vulnerability/CreateReportVulnerabilityForm";

export const CreateReportVersionVulnerabilityScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(createReportVersionVulnerabilityRoute);
    const [created, setCreated] = useState(false);

    return created ? (
        <Navigate to={editReportVersionVulnerabilitiesRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={createReportVersionVulnerabilityRoute} />
                <CreateReportVulnerabilityForm versionId={versionId} onCreate={() => setCreated(true)} />
            </Container>
        </NavigationScreen>
    );
};
